import { defineAsyncComponent } from 'vue';
import Button from 'primevue/button';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Card from 'primevue/card';
import Tag from 'primevue/tag';
import Message from 'primevue/message';
import Skeleton from 'primevue/skeleton';
export function installComponents(app) {
  Object.entries({ Column, Button, InputText, Card, Tag, Message, Skeleton }).forEach(([name, component]) => app.component(name, component));
  app.component('Password', defineAsyncComponent(() => import('primevue/password')));
  app.component('InputNumber', defineAsyncComponent(() => import('primevue/inputnumber')));
  app.component('Select', defineAsyncComponent(() => import('primevue/select')));
  app.component('DatePicker', defineAsyncComponent(() => import('primevue/datepicker')));
  app.component('FileUpload', defineAsyncComponent(() => import('primevue/fileupload')));
  app.component('ToggleSwitch', defineAsyncComponent(() => import('primevue/toggleswitch')));
  app.component('DataTable', defineAsyncComponent(() => import('primevue/datatable')));
  app.component('DataView', defineAsyncComponent(() => import('primevue/dataview')));
  app.component('Dialog', defineAsyncComponent(() => import('primevue/dialog')));
  app.component('ConfirmDialog', defineAsyncComponent(() => import('primevue/confirmdialog')));
  app.component('Menu', defineAsyncComponent(() => import('primevue/menu')));
  app.component('Drawer', defineAsyncComponent(() => import('primevue/drawer')));
  app.component('Toolbar', defineAsyncComponent(() => import('primevue/toolbar')));
  app.component('Tabs', defineAsyncComponent(() => import('primevue/tabs')));
  app.component('TabList', defineAsyncComponent(() => import('primevue/tablist')));
  app.component('Tab', defineAsyncComponent(() => import('primevue/tab')));
  app.component('TabPanels', defineAsyncComponent(() => import('primevue/tabpanels')));
  app.component('TabPanel', defineAsyncComponent(() => import('primevue/tabpanel')));
  app.component('Timeline', defineAsyncComponent(() => import('primevue/timeline')));
  app.component('Paginator', defineAsyncComponent(() => import('primevue/paginator')));
  app.component('Accordion', defineAsyncComponent(() => import('primevue/accordion')));
  app.component('AccordionPanel', defineAsyncComponent(() => import('primevue/accordionpanel')));
  app.component('AccordionHeader', defineAsyncComponent(() => import('primevue/accordionheader')));
  app.component('AccordionContent', defineAsyncComponent(() => import('primevue/accordioncontent')));
  app.component('SelectButton', defineAsyncComponent(() => import('primevue/selectbutton')));
  app.component('Textarea', defineAsyncComponent(() => import('primevue/textarea')));
  app.component('RadioButton', defineAsyncComponent(() => import('primevue/radiobutton')));
}
